import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CatalogItemImage from 'rebook/apps/catalog/components/CatalogItemImage';
import pluralize from 'rebook/apps/utils/text/pluralize';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';

import styles from './style.scss';


const CatalogItem = ({ children, imageSrc, withArrow, count = null, theme }) => {
  const blockImage = withArrow
    ? <span className={styles.arrow} />
    : (
      <div className={styles.image}>
        <CatalogItemImage imageSrc={imageSrc} />
      </div>
    );

  return (
    <div className={classNames(styles.content, theme && styles[`${theme}Theme`])}>
      <div className={styles.inner}>
        {children}
        {count && (
          <div className={styles.count}>
            {numberWithSpace(count)} {pluralize(count, 'книга', 'книги', 'книг')}
          </div>
        )}
      </div>
      {blockImage}
    </div>
  );
};

CatalogItem.propTypes = {
  imageSrc: PropTypes.string,
  withArrow: PropTypes.bool,
  count: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
};

export default CatalogItem;
